export const SDK_URLS = {
  PORTONE: "https://cdn.portone.io/v2/browser-sdk.js",
  IAMPORT: "https://cdn.iamport.kr/v1/iamport.js",
};